import { useEffect, useState } from "react";
import M from 'materialize-css';
import { getMantenimientoConfig } from "../firestore";
import { ICONS } from "../assets/icons";

function ModalMantenimiento() {

    const [instanceModal, setInstanceModal] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        M.Modal.init(document.getElementById('modalMantenimiento'), {
            dismissible: false,
            opacity: 1,
            endingTop: '10%'
        });
        setInstanceModal(M.Modal.getInstance(document.getElementById('modalMantenimiento')));

        getMantenimiento();
    }, []);

    useEffect(()=> {

        if (showModal && instanceModal) {
            instanceModal.open();
        }
        if (!showModal && instanceModal) {
            instanceModal.close();
        }

    }, [showModal]);


    const getMantenimiento = async () => {
        const mantenimientoConfig = await getMantenimientoConfig();

        if (mantenimientoConfig && mantenimientoConfig.showMantenimiento) {
            setShowModal(true);
        }
    }

    return (
        <div id="modalMantenimiento" className="modal">
            <div className="modal-content">
                <div className="row">
                    <div className="col s12 center-align">
                        <p className="txtBold ft-28 txtColorBlueV mb-0 mt-0">¡Mantenimiento programado!</p>

                        <img src={ICONS.mantenimientoimg} alt="Mantenimiento" className="responsive-img" style={{ maxWidth: '500px' }} />

                        <p className="ft-16 mb-0" style={{color:'#81879E'}}>Durante este fin de semana estaremos realizando trabajos de mantenimiento,</p>
                        <p className="ft-16 mt-0" style={{color:'#81879E'}} > por lo que la aplicación no estará disponible durante este periodo.</p>
                        <p className="ft-16" style={{color:'#81879E'}}>¡Agradecemos tu comprensión!</p>

                        <div className="row">
                            <div className="col s12 mt-1">
                                <button type="button" className="btn btn-webSi-alert waves-effect light"
                                    onClick={() => {
                                        setShowModal(false);
                                        window.location.reload();
                                    }}
                                >Entendido</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )

}

export default ModalMantenimiento;